import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PanelComponent } from '@components/core/panel/panel.component';
import { EntityService } from '@services/core/entity.service';
import { ModuleService } from '@services/core/module.service';
import { EditEntityComponent } from './editEntity/editEntity.component';
import { ActivatedRoute } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { collectEntityModules, mergeActiveModules, sortModuleColumns, findModuleLink, auditorDisplayName } from './entity-columns.helper';
import { missingIdentity, matchEntityText, normQuery } from './entity-filter.helper';

@Component({
	selector: 'app-entities',
	templateUrl: './entities.component.html',
	styleUrls: ["./entities.component.css"],
    imports: [CommonModule, PanelComponent, EditEntityComponent, NgbTooltipModule],
	changeDetection: ChangeDetectionStrategy.Default,
	standalone: true,
})
export class EntitiesComponent implements OnInit{
    protected entities
    protected entity
    private entitiesTemp
    protected showEditEntity = false
    private entityService = inject(EntityService)
    private moduleService = inject(ModuleService)
    private route = inject(ActivatedRoute)
    private destroyRef = inject(DestroyRef)
    protected moduleColumns: any[] = []
    private allModules: any[] = []
	

	ngOnInit(): void {
	    const data = this.route.snapshot.data['entitiesData']
	    if (!data) return
	    this.entities = data.entities
	    this.entitiesTemp = data.entitiesTemp
	    this.buildModuleColumns()
	    this.loadModuleColumns()
	}

    private loadModuleColumns() {
        this.moduleService.getActiveModules().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: (mods: any[]) => {
                this.allModules = mods || []
                this.buildModuleColumns()
            }
        })
    }

    private buildModuleColumns() {
        const found = collectEntityModules(this.entities || [])
        mergeActiveModules(found, this.allModules || [])
        this.moduleColumns = sortModuleColumns([...found.values()])
    }

    auditorFor(entity: any, moduleId: string): string {
        return auditorDisplayName(findModuleLink(entity, moduleId))
    }
    
    getEntities(){
        this.entity = null
        this.showEditEntity = false
        this.entityService.getEntities().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: (res) => {
                this.entities = res
                this.entitiesTemp = res
                this.buildModuleColumns()
            },
            error: (err) => console.error('Error al obtener entidades:', err)
        })
    }

    private matchEntity(entity: any, value: string): boolean {
        if (missingIdentity(entity)) return false
        return matchEntityText(entity, normQuery(value))
    }

    filterEntities(value: string) {
        this.entities = value.length >= 3
            ? this.entitiesTemp.filter(e => this.matchEntity(e, value))
            : this.entitiesTemp
    }

    addEntity(){
        this.entity = null
        this.showEditEntity = true
    }

    setEditEntity(entity: any){
        this.entity = entity
    }

    activeDeactiveEntity(entity: any){
        entity.enabled = !entity.enabled
        this.entityService.updateEntity(entity).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: (res) => {
                this.getEntities()
            },
            error: (err) => console.error('Error al actualizar entidad:', err)
        })
    }
}
